/* eslint-disable no-plusplus */
import _ from 'underscore';

function commonConvertTargetStateToTargetSchema({
  campaign, target, CriterionType, targetCriterion,
}) {
  const { useParentLevel } = target;
  const currentLevelSettings = [...target.currentLevelSettings];
  let newCurrentLevelSettings = [];
  const targetSchema = [];
  if (useParentLevel) {
    for (let i = 0; i < currentLevelSettings.length; i++) {
      const item = { ...currentLevelSettings[i] };
      if (item.Id) {
        item.Status = 'Deleted';
        newCurrentLevelSettings.push(item);
      } else {
        currentLevelSettings.splice(i, 1);
        i--;
      }
    }
  } else {
    newCurrentLevelSettings = currentLevelSettings;
  }
  newCurrentLevelSettings.sort(a => (a.Status === 'Deleted' ? -1 : 1)); // Place the deleted item in front of the array
  const parentParams = {};
  if (campaign.Id) {
    parentParams.Campaign = { Id: campaign.Id };
  } else {
    parentParams.CampaignName = campaign.name.value;
  }
  for (let i = 0; i < newCurrentLevelSettings.length; i++) {
    const item = newCurrentLevelSettings[i];
    if (item) {
      targetSchema.push({
        Id: item.Id,
        CriterionType,
        ...parentParams,
        Status: item.Status,
        Criterion: {
          BidAdjustment: item.bidAdjustmentDropdown === 'Increase by' ? item.bidAdjustmentInput - 0 : -(item.bidAdjustmentInput - 0),
          Type: CriterionType,
          ...targetCriterion(item),
        },
      });
    }
  }
  return { targetSchema, currentLevelSettings: newCurrentLevelSettings };
}

export const convertDeviceStateToDeviceSchema = (campaign, initTargets) => {
  const DeviceMap = {
    Tablet: 'Tablets',
    Computer: 'Computers',
    Smartphone: 'Smartphones',
  };
  const currentDeviceSchema = commonConvertTargetStateToTargetSchema({
    campaign,
    target: campaign.device,
    CriterionType: 'Device',
    targetCriterion(item) {
      return { DeviceCriterion: { DeviceName: DeviceMap[item.device] } };
    },
  });

  let currentDeviceSchemaResult = [];
  if (!_.isEqual(initTargets.device, currentDeviceSchema.currentLevelSettings)) {
    currentDeviceSchemaResult = currentDeviceSchema.targetSchema;
  }
  return currentDeviceSchemaResult;
};

export const convertABWStateToABWSchema = campaign => commonConvertTargetStateToTargetSchema({
  campaign,
  target: campaign.ABW,
  CriterionType: 'AdvanceBookingWindow',
  targetCriterion(item) {
    return { AdvanceBookingWindowCriterion: { MinDays: item.minimumDays, MaxDays: item.maximumDays } };
  },
});

export const convertCheckInDayStateToCheckInDaySchema = campaign => commonConvertTargetStateToTargetSchema({
  campaign,
  target: campaign.checkinDay,
  CriterionType: 'CheckInDay',
  targetCriterion(item) {
    return { CheckInDayCriterion: { CheckInDay: item.day } };
  },
});

export const convertLengthofStayStateToLengthofStaySchema = campaign => commonConvertTargetStateToTargetSchema({
  campaign,
  target: campaign.lengthOfStay,
  CriterionType: 'LengthofStay',
  targetCriterion(item) {
    return { LengthOfStayCriterion: { MinNights: item.minimumNumber, MaxNights: item.maximumNumber } };
  },
});

export const convertCheckInDateStateToCheckInDateSchema = campaign => commonConvertTargetStateToTargetSchema({
  campaign,
  target: campaign.checkinDate,
  CriterionType: 'CheckInDate',
  targetCriterion(item) {
    return { CheckInDateCriterion: { StartDate: item.startDate, EndDate: item.endDate } };
  },
});

export const convertUserSetDatesStateToUserSetDatesSchema = (campaign) => {
  const UserSetDateMap = {
    'Selected date': 'UserSelection',
    'Defaulted date': 'DefaultSelection',
  };
  return commonConvertTargetStateToTargetSchema({
    campaign,
    target: campaign.userSetDates,
    CriterionType: 'DateSelectionType',
    targetCriterion(item) {
      return { DateSelectionTypeCriterion: { HotelDateSelectionType: UserSetDateMap[item.dates] } };
    },
  });
};
